import { SaveButton } from "components/Buttons"
import { AsyncTypeahedSelect } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import { Field, formValueSelector } from "redux-form"
import {
  getUsersBySearch,
  updateFeatureRecipient,
} from "store/actions"

const ResponsesTab = props => {
  return (
    <Card>
      <CardBody>
        <Row className="mt-1 mb-3">
          <Col>
            Select admins which will get a copy of each filled out form builder:
          </Col>
        </Row>
        <Row>
          <Col>
            <Field
              name="selectedAdmins"
              component={AsyncTypeahedSelect}
              placeholder="Search for specific users"
              inlineValue={false}
              isMulti={true}
              options={props.usersBySearch.map(user => ({
                label: `${user?.first_name} ${user?.last_name} (${user?.email})`,
                value: user.id,
              }))}
              onInputChange={text =>
                props.getUsersBySearch({
                  include_admins: true,
                  only_admins: true,
                  t: text,
                })
              }
            />
          </Col>
        </Row>
        <Row className="mt-3 justify-content-center">
          <Col xs="auto">
            <SaveButton
              disabled={!props?.feature?.entity_id}
              type="button"
              content="Save"
              onClick={() => {
                props.updateFeatureRecipient({
                  feature_id: props?.feature?.entity_id,
                  feature_type: "form_builder",
                  vendor_id: props.vendorId,
                  user_ids: props.selectedAdmins?.map(user => user?.value),
                })
              }}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const selector = formValueSelector(FORM_NAMES.FORM_BUILDER)

const mapStateToProps = state => ({
  selectedAdmins: selector(state, "form_builder_form.responses.selectedAdmins"),
  vendorId: state.Login.vendorId,
  usersBySearch: state.SiteUsers.usersBySearch,
})

const mapDispatchToProps = dispatch => ({
  updateFeatureRecipient: values => dispatch(updateFeatureRecipient(values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ResponsesTab)
